import { ensureValidToken } from './token-manager'

export type SessionStatus = 'authed' | 'unauthed'

/**
 * Decide whether the current session can make authenticated requests.
 *
 * `ensureValidToken()` returns a usable access token for a valid or
 * refreshable session, and `null` when there is no session or a refresh
 * failed (in which case token-manager has already cleared the session). A
 * usable token means `authed`; anything else means `unauthed`.
 *
 * ProtectedRoute uses this to gate rendering, so protected children never
 * mount — and therefore never fire token-less requests, the source of the
 * "No auth token" 401 flood from stale webview sessions (Sentry BACKEND-6K).
 */
export async function resolveSessionStatus(): Promise<SessionStatus> {
  const token = await ensureValidToken()
  return token ? 'authed' : 'unauthed'
}
